import { memo } from "react";

import {
  type PaginationData,
  type PaginationItem,
  type Splide,
} from "@splidejs/splide";

import { useCarouselPaginationAria } from "@react/a11y/carouselAria";
import {
  PAGINATION_ACTIVE_CLASS,
  PAGINATION_INACTIVE_CLASS,
} from "@react/components/Carousel/constants";
import { tw, type TTailwindString } from "classnames";

interface Props {
  carouselId?: string;
  className?: TTailwindString;
  currentSlide?: number;
  totalSlides?: number;
}

const styles = {
  wrapper: (className?: TTailwindString) =>
    tw(
      "splide__pagination" as TTailwindString,
      "m-0",
      "list-none",
      "p-0",
      className ? tw(className) : undefined
    ),
};

const CarouselPaginationDotsBase = ({
  carouselId,
  className,
  currentSlide = 0,
  totalSlides = 1,
}: Props) => {
  const paginationAria = useCarouselPaginationAria({
    carouselId,
    totalSlides,
    currentSlide,
    slideIndex: currentSlide,
  });

  return <ul className={styles.wrapper(className)} {...paginationAria}></ul>;
};

export const onPaginationUpdated = (
  Splide: Splide,
  data: PaginationData,
  prev: PaginationItem,
  curr: PaginationItem
) => {
  // Update visual classes
  prev.button.classList.add(PAGINATION_INACTIVE_CLASS);
  prev.button.classList.remove(PAGINATION_ACTIVE_CLASS);

  curr.button.classList.add(PAGINATION_ACTIVE_CLASS);
  curr.button.classList.remove(PAGINATION_INACTIVE_CLASS);

  // Update ARIA attributes
  prev.button.setAttribute("aria-current", "false");
  curr.button.setAttribute("aria-current", "page");
};

export const CarouselPaginationDots = memo(CarouselPaginationDotsBase);
